import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { CreateDepot, DepotCreated, createDepot } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateDepot = (
  options: UseMutationOptions<DepotCreated, unknown, CreateDepot, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (depot) => extractData(createDepot({ body: depot })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['depots'],
      });
      options.onSuccess?.(...args);
    },
  });
};
